import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import {permissions} from './constants'

export const userIsAuthenticated = connectedRouterRedirect({
   // The url to redirect user to if they fail
  redirectPath: '/',
   // Determine if the user is authenticated or not
  authenticatedSelector: state => { return typeof state.user.email !== 'undefined' },
  // A nice display name for this check
  wrapperDisplayName: 'userIsAuthenticated'
});
export const userNotAuthenticated = connectedRouterRedirect({
   // The url to redirect user to if they fail
  redirectPath: '/dashboard',
   // Determine if the user is authenticated or not
  authenticatedSelector: state => { return typeof state.user.email === 'undefined' },
  // A nice display name for this check
  wrapperDisplayName: 'userNotAuthenticated'
});


export const userIsAdmin = connectedRouterRedirect({
  // The url to redirect user to if they fail
 redirectPath: '/dashboard',
  // Determine if the user is authenticated or not
 authenticatedSelector: state => { return state.user.permissions >=  permissions.Admin},
 // A nice display name for this check
 wrapperDisplayName: 'userIsAdmin'
});



// WEBPACK FOOTER //
// ./src/auth.js